import React, { createContext, useContext, ReactNode } from 'react'
import { CheckoutFlow } from '../flow/type'

export interface FlowContextValue {
  flowName: CheckoutFlow
}

const FlowContext = createContext<FlowContextValue | undefined>(undefined)

export interface FlowProviderProps {
  flowName: CheckoutFlow
  children: ReactNode
}

export const FlowProvider: React.FC<FlowProviderProps> = ({ flowName, children }) => {
  const value: FlowContextValue = { flowName }

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>
}

export const useFlowContext = (): FlowContextValue => {
  const context = useContext(FlowContext)

  if (context === undefined) {
    throw new Error('useFlowContext must be used within a FlowProvider. Make sure you have wrapped your app with <FlowProvider> in _app.tsx.')
  }

  return context
}
